var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98251 0C2.67846 0 0 2.67846 0 5.98251C0 9.28656 2.67846 11.965 5.98251 11.965H10L10 0H5.98251ZM12 0L12 11.965H16.0175C19.3215 11.965 22 9.28656 22 5.98251C22 2.67846 19.3215 0 16.0175 0H12Z",
    fill: "#F5BD84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillOrange);
export default __webpack_public_path__ + "static/media/pill-orange.0f07e1d7c7408e3a069c7795e3a03277.svg";
export { ForwardRef as ReactComponent };